module.exports = __webpack_public_path__ + "img/q3-1-active.ffaaac6f.png";